import React, { Component, Children } from 'react';
import { Icon } from 'ui';

/**
 * @todo replace Tags/TagsList with this component
 */
class ExpandableList extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggleList = this.toggleList.bind(this);
  }

  static defaultProps = {
    collapseAt: 3,
  };

  static CollapseButton({ onClick, children, icon }) {
    return (
      <button type="button" className="u-linkBtn p-4" onClick={onClick}>
        {children}
        <Icon name={icon} className="ml-4 fz-xs" />
      </button>
    );
  }

  get childrenCount() {
    return this.props.children.length;
  }

  renderExpandButton() {
    const { collapseAt } = this.props;
    const Btn = props =>
      this.constructor.CollapseButton({ ...props, onClick: this.toggleList });
    if (this.childrenCount <= collapseAt) return false;
    if (this.state.expanded) return <Btn icon="triangle_up">Show fewer</Btn>;
    return (
      <Btn icon="triangle_down">
        Show {this.childrenCount - (collapseAt - 1)} More
      </Btn>
    );
  }

  toggleList() {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  renderChildren() {
    const { children, collapseAt } = this.props;
    if (this.state.expanded || this.childrenCount <= collapseAt)
      return children;
    const childrenArray = Children.toArray(children);
    return childrenArray.slice(0, collapseAt - 1);
  }

  render() {
    if (this.props.children.length === 0) {
      return false;
    }

    if (!this.props.collapsible) {
      return <div>{this.props.children}</div>;
    }

    return (
      <div>
        {this.renderChildren()}
        {this.renderExpandButton()}
      </div>
    );
  }
}

export default ExpandableList;
